import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import translations from '../../shared/Translations';
import superAdminApis from '../../api/services/admin-pages/superAdmin';
import { baseURL } from '../../api/api';
import './index.css'
import NoImage from '../../assets/images/noimages.jpg'
import { FaPrint } from 'react-icons/fa';
import logo from "../../assets/images/Asset 12 5.png";

import AOS from "aos";
import "aos/dist/aos.css";

function CustomerView() {

     const navigate = useNavigate();

      useEffect(() => {
        
          AOS.init({
            duration: 1000,  
            once: false,    
            mirror: true,    
          });
        }, []);


        const [lang, setLang] = useState("en");
      const t = (key) => translations[lang][key] || key;
       const [loading, setLoading] = useState(false)
     
      useEffect(() => {
         const savedLang = localStorage.getItem("lang");
         if (savedLang) setLang(savedLang);
       }, []);

     const handleBackCustomer = () => {
    navigate("/customer-list");
  };




    const { id } = useParams();
  const baseURLs = baseURL;
  const [customer, setCustomer] = useState(null);


  useEffect(() => {
    setLoading(true)
  if (id) {
    superAdminApis
      .customerDetailsGet(id)
      .then((res) => {
        if (res?.apiStatus?.code === "200") {
              setLoading(false)

          const result = Array.isArray(res.result) ? res.result[0] : res.result;

          // ✅ Ensure valid existing_details array
          const existingDetails =
            Array.isArray(result?.existing_details) &&
            result.existing_details.length > 0 &&
            result.existing_details[0] !== null
              ? result.existing_details
              : [];

          // ✅ Flatten payment-like details
          let mergedList = [];

          existingDetails.forEach((item) => {
            if (!item) return;
            Object.values(item).forEach((entry) => {
              if (!entry) return;

              mergedList.push({
                month_no: mergedList.length + 1,
                loan_id : entry.loan_id,
                name : entry.name,
                payment_date:
                  entry.last_payment_date && entry.last_payment_date !== "0000-00-00"
                    ? entry.last_payment_date
                    : entry.updated_date || entry.created_date || "-",
                interest_paid: entry.interest_paid || 0,
                principal_paid: entry.principal_paid || 0,
                total_paid:
                  Number(entry.interest_paid || 0) + Number(entry.principal_paid || 0),
                balance:
                  entry.balance ||
                  entry.remaining_balance ||
                  entry.total_amount ||
                  result.loan_amount ||
                  0,
              });
            });
          });

          console.log("✅ Final merged history:", mergedList);

          // ✅ Set final customer data
          setCustomer({
            ...result,
            mergedHistory: mergedList,
          });
        } else {
          console.error("❌ API returned non-200 status:", res);
                        setLoading(false)

         setCustomer({}); 
        }
      })
      .catch((err) => {
        console.error("❌ Error fetching details:", err);
       setCustomer({}); 
      });
  }
}, [id]);


 const loanAmount = Number(customer?.loan_amount || 0);
  const principalPaid = Number(customer?.principal_paid || 0);
  const interestPaid = Number(customer?.interest_amount || 0);
  const totalPaid = principalPaid + interestPaid;

  let principalRemaining = loanAmount - principalPaid;

  console.log(principalRemaining,loanAmount,principalPaid);
  
  if (principalRemaining < 0) principalRemaining = 0;

  const loanStatus =
    principalRemaining === 0 ? "Closed" : customer.paid_status || "Active";

  const balance = principalRemaining.toFixed(2);


  // Step 1: Flatten and sort the merged history by payment_date ascending

const sortedHistory = [...(customer?.mergedHistory || [])].sort(
  (a, b) => new Date(a.payment_date) - new Date(b.payment_date)
);
// Step 2: Track first interest payment per month
const firstInterestByMonth = {};

// Step 3: Map for rendering
const rowsToRender = sortedHistory.map((p, i) => {
  const dateObj = new Date(p.payment_date);
  const monthKey = `${dateObj.getFullYear()}-${dateObj.getMonth()}`; // "2025-11" style

  let interestToShow = Number(p.interest_paid);

  // If this month already has a first interest row, set interest = 0
  if (firstInterestByMonth[monthKey]) {
    interestToShow = 0;
  } else if (interestToShow > 0) {
    // Mark this row as the first interest payment of the month
    firstInterestByMonth[monthKey] = true;
  }

  return {
    ...p,
    display_interest: interestToShow,
  };
});

const handlePrint = (row) => {
  const printWindow = window.open("", "_blank");

  printWindow.document.write(`
<html>
<head>
<title>Receipt</title>

<style>
* {
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}

body {
  font-family: 'Segoe UI', sans-serif;
  background: #eef2f7;
  padding: 20px;
}

/* CARD */
.receipt {
  max-width: 520px;
  margin: auto;
  background: #fff;
  border-radius: 14px;
  padding: 25px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.08);
  border-top: 6px solid #28a745;
}

/* HEADER */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.logo-box {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-box img {
  width: 60px;
}

.company-name {
  font-size: 18px;
  font-weight: bold;
  color: #28a745;
}

.shop-details {
  text-align: right;
  font-size: 12px;
  color: #666;
}

/* TITLE */
.title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin: 15px 0;
  color: #333;
}

/* SECTION BOX */
.section {
  background: #f8fafc;
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 15px;
}

/* ROW */
.row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
}

.row label {
  color: #666;
  font-weight: 600;
}

/* TOTAL */
.total {
  background: #e8fff1;
  padding: 12px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  color: #28a745;
}

/* BALANCE */
.balance {
  color: #dc3545;
  font-weight: bold;
}

/* SIGN */
.signature {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  font-size: 12px;
}

/* FOOTER */
.footer {
  text-align: center;
  margin-top: 45px;
  font-size: 14px;
  color: #4e4b4b;
}

/* PRINT */
@media print {
  body { background: #fff; }
  .receipt {
    box-shadow: none;
    border: none;
  }
}
</style>

</head>

<body>

<div class="receipt">

  <!-- HEADER -->
  <div class="header">
    <div class="logo-box">
      <img style="width:120px;" src="${logo}" />
     
    </div>

    <div class="shop-details">
      Chennai, Tamil Nadu <br/>
      📞 9876543210
    </div>
  </div>

  <!-- TITLE -->
  <div class="title">Payment Receipt</div>

  <!-- CUSTOMER INFO -->
  <div class="section">
    <div class="row">
      <label>Loan No:</label>
      <span>${row.loan_id}</span>
    </div>

    <div class="row">
      <label>Name:</label>
      <span>${row.name}</span>
    </div>

    <div class="row">
      <label>Date:</label>
      <span>${row.payment_date ? formatDate(row.payment_date) : "-"}</span>
    </div>

    <div class="row">
      <label>Time:</label>
      <span>${row.payment_date ? formatTime(row.payment_date) : "--:--:--"}</span>
    </div>
  </div>

  <!-- PAYMENT INFO -->
  <div class="section">
    <div class="row">
      <label>Principal:</label>
      <span>₹${row.principal_paid}</span>
    </div>

    <div class="row">
      <label>Interest:</label>
      <span>₹${row.interest_paid}</span>
    </div>

    <div class="total">
      <span>Total Paid:</span>
      <span>₹${(Number(row.principal_paid) + Number(row.interest_paid)).toFixed(2)}</span>
    </div>

    <div class="row" style="margin-top:10px;">
      <label>Balance:</label>
      <span class="balance">₹${row.balance}</span>
    </div>
  </div>

  <!-- SIGN -->
  <div class="signature">
    <span>Customer Sign</span>
    <span>Authorized Sign</span>
  </div>

  <!-- FOOTER -->
  <div class="footer">
    Thank you for your payment 🙏 <br/>
    Visit Again!
  </div>

</div>

</body>
</html>
`);

  printWindow.document.close();
  printWindow.print();
};

   const formatTime = (dateStr) => {
    if (!dateStr || dateStr === "0000-00-00") return "—";
    const d = new Date(dateStr.replace(" ", "T"));
    return d.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // show AM/PM
    });
  };

const formatDate = (dateStr) => {
  if (!dateStr || dateStr === "0000-00-00") return "—";

  const [datePart] = dateStr.split(" ");        
  const [y, m, d] = datePart.split("-");       

  return `${d}-${m}-${y}`;                     
};

if (!customer) {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      <div className="gold-dots-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}


const jewelName = customer?.jewel_name || "";

const isLongName =
  jewelName.includes(",") || jewelName.length > 25;


  return (
    <div>


<div className="d-flex justify-content-between align-items-center mt-3 mb-4">

  {/* Breadcrumb */}
  <nav aria-label="breadcrumb" className={lang === "ta" ? "fs-tamil" : ""}>
    <ol className="breadcrumb mb-0">

      <li className="breadcrumb-item">
        <a href="#" onClick={handleBackCustomer}>
          {t("dashboard")}
        </a>
      </li>

      <li className="breadcrumb-item active" aria-current="page">
        {t("customerView")}
      </li>

    </ol>
  </nav>

  {/* Button */}
  <div>
    <button className={`btn add-customer `} onClick={handleBackCustomer}>
      <i className="fa fa-arrow-left me-2"></i>
      {t("back")}
    </button>
  </div>

</div>


<div className="customer-list-container card">
 
<div className="view-container">

  {/* TOP SECTION */}
<div className="top-section"  data-aos="fade-up-right">

  {/* LEFT IMAGE */}
  <div className="image-box profile-card">
    <div className="image-wrapper">
      <img
        src={
          customer?.liveImage?.altered_file_name
            ? `${baseURLs}${customer.liveImage.path}${customer.liveImage.altered_file_name}`
            : NoImage
        }
        alt="Customer"
      />
    </div>
  </div>

  {/* RIGHT DETAILS */}
  <div className="info-box">

  <div className="info-grid">

    <div className='name-side-gap'>
      <p><strong>Name:</strong> {customer?.name || '--'}</p>
      <p><strong>Guardian Name:</strong> {customer?.guardian_name || '--'}</p>
      <p><strong>Phone:</strong> {customer?.phone_no || '--'}</p>
      <p><strong>Address:</strong> {customer?.address || '--'}</p>
    </div>

    <div className='name-side-gap'>
      <p><strong>Loan Start Date:</strong> {formatDate(customer?.date)}</p>

      <p>
        <strong>Total Loan Amount:</strong> ₹
        {customer?.additionalAmtDetails?.additional_loan_amt
          ? Number(customer?.previous_loan_amount) +
            Number(customer?.additionalAmtDetails?.additional_loan_amt)
          : customer?.previous_loan_amount}
      </p>

      <p><strong>Interest Rate:</strong> {customer?.intrest_rate}%</p>

      <p>
        <strong>Status:</strong>{" "}
        <span className={`status-badge ${loanStatus === "Closed" ? "closed" : "active"}`}>
          {loanStatus}
        </span>
      </p>
    </div>

  </div>

</div>

</div>

  {/* TABLE SECTION */}

         {/* ===== LOAN SUMMARY ===== */}
<div className="shadow-sm p-4 mb-4 rounded bg-white border mt-3" data-aos="fade-right">

  <h6 className="fw-bold mb-3 text-primary">Loan Summary</h6>
  
  <div className="row mb-3">

    {/* Loan Id */}

     <div className={`mb-2 ${customer?.additionalAmtDetails?.additional_loan_amt ? "col-md-3" : "col-md-4"}`}>
    <div className="p-3 rounded border bg-light shadow">
      <small className="text-muted">Loan Id</small>
      <h6 className="fw-bold mt-1">{customer?.loan_id}</h6>
    </div>
  </div>

  {/* Total Loan Amount */}
  <div className={`mb-2 ${customer?.additionalAmtDetails?.additional_loan_amt ? "col-md-3" : "col-md-4"}`}>
    <div className="p-3 rounded border bg-light shadow">
      <small className="text-muted">Loan Amount</small>
      <h6 className="fw-bold mt-1">₹{customer?.previous_loan_amount}</h6>
    </div>
  </div>

   

  {/* Additional Loan Amount → show only if value exists */}
  {customer?.additionalAmtDetails?.additional_loan_amt && (
    <div className="col-md-3 mb-2">
      <div className="p-3 rounded border bg-light shadow">
        <small className="text-muted">Additional Loan Amount</small>
        <h6 className="fw-bold mt-1">
          ₹{customer.additionalAmtDetails.additional_loan_amt}
        </h6>
      </div>
    </div>
  )}


  {/* <div className={`mb-2 ${customer?.additionalAmtDetails?.additional_loan_amt ? "col-md-4" : "col-md-4"}`}>
    <div className="p-3 rounded border bg-light shadow">
      <small className="text-muted">Jewel Less Weight & Jewel Amount</small>
      <h6 className="fw-bold mt-1">{customer?.jewel_weight} gram  ---  ₹{customer.jewel_amount}</h6>
    </div>
  </div> */}


  {/* Interest Rate */}
  <div className={`mb-2 ${customer?.additionalAmtDetails?.additional_loan_amt ? "col-md-3" : "col-md-4"}`}>
    <div className="p-3 rounded border bg-light shadow">
      <small className="text-muted">Interest Rate</small>
      <h6 className="fw-bold mt-1">{customer.intrest_rate}%</h6>
    </div>
  </div>



<div className={isLongName ? "col-12 mt-3" : "col-md-4 mt-3"} >
  <div className="p-3 rounded border bg-light shadow">
      <small className="text-muted">Jewel Name</small>
<h6 className="fw-bold mt-1">
  {customer?.jewel_name 
    ? `${customer.jewel_name}`
    : "0"}
</h6>
    </div>
</div>

{/* Jewel Weight */}
<div className={isLongName ? "col-md-6 mt-3" : "col-md-4 mt-3"}>
  <div className="p-3 rounded border bg-light shadow">
    <small className="text-muted">Jewel Weight</small>
    <h6 className="fw-bold mt-1">
      {customer?.jewel_dust_weight
        ? `${customer.jewel_dust_weight} Grams`
        : "0"}
    </h6>
  </div>
</div>

{/* Jewel Less Weight */}
<div className={isLongName ? "col-md-6 mt-3" : "col-md-4 mt-3"}>
  <div className="p-3 rounded border bg-light shadow">
    <small className="text-muted">Jewel Less Weight</small>
    <h6 className="fw-bold mt-1">
      {customer?.jewel_weight
        ? `${customer.jewel_weight} Grams`
        : "0"}
    </h6>
  </div>
</div>

{/* Jewel Amount */}

{/* <div className={isLongName ? "col-md-4 mt-3" : "col-md-3 mt-3"}>
  <div className="p-3 rounded border bg-light shadow">
    <small className="text-muted">Jewel Amount</small>
    <h6 className="fw-bold mt-1">
      ₹{customer?.jewel_amount || 0}
    </h6>
  </div>

</div> */}


</div>
  </div>


<div className="table-section mt-5" >
 <h6 className="fw-bold mb-3">📅 Payment Overview</h6> 

{Array.isArray(customer?.mergedHistory) && customer?.mergedHistory.length > 0 ? (
    <table >
      <thead>
        <tr>
          <th>Sl No</th>
          <th>Payment Date</th>
          <th>Payment Time</th>
          <th>Principal Paid</th>

          <th>Interest Paid</th>
          <th>Total Paid</th>
          <th>Remaining Balance</th>
          <th>Print</th>
        </tr>
      </thead>
    <tbody>

    {loading ? (
      <tr>
        <td colSpan="8" className="text-center">
          <div className="gold-dots-loader">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </td>
      </tr>
    ) : Array.isArray(customer?.mergedHistory) && customer?.mergedHistory.length > 0 ? (

      rowsToRender.map((p, i) => {
        const [datePart, timePart] = (p.payment_date || "-").split(" ");
        return (
          <tr key={i}>
            <td>{p.month_no}</td>
            <td>{datePart !== "-" ? formatDate(p.payment_date) : "-"}</td>
            <td>{timePart ? formatTime(p.payment_date) : "--:--:--"}</td>
            <td>₹{p.principal_paid}</td>
            <td>₹{p.display_interest}</td>
            <td>₹{(Number(p.principal_paid) + p.display_interest).toFixed(2)}</td>
            <td>₹{p.balance}</td>
            <td
              style={{ color: "blue", cursor: "pointer" }}
              onClick={() => handlePrint(p)}
            >
              <FaPrint size={18} />
            </td>
          </tr>
        );
      })

    ) : (
      <tr>
        <td colSpan="8" className="text-center text-muted">
          No payment history available
        </td>
      </tr>
    )}

  </tbody>

    </table>
  ) : (
    <p className="text-muted">No payment history available</p>
  )}
</div>

 <div className="shadow p-4 mt-5" >
  <h6 className="fw-bold mb-4">Uploaded Images</h6>
  <div className="row">
    
    <div className="col-md-3">
      <div className="card-view p-0">
        
        <div className="fancy-card-image">
         <img
      src={
        customer.aadharImage?.[0]
          ? `${baseURLs}${customer?.aadharImage[0].path}${customer?.aadharImage[0].altered_file_name}`
          : NoImage
      }
      alt="Aadhaar Front"
       className="fancy-img"
    />
        </div>

        <div className="card-content d-flex flex-column align-items-center">
          <h4 className="pt-2 image-content-letter">Aadhar Front Image</h4>
         

        </div>

      </div>
    </div>

     <div className="col-md-3">
      <div className="card-view p-0">
        
        <div className="fancy-card-image">
         <img
      src={
        customer?.aadharImage?.[1]
          ? `${baseURLs}${customer?.aadharImage[1].path}${customer?.aadharImage[1].altered_file_name}`
          : NoImage
      }
      alt="Aadhaar Back"
       className="fancy-img"
    />
        </div>

        <div className="card-content d-flex flex-column align-items-center">
          <h4 className="pt-2 image-content-letter">Aadhar Back Image</h4>

          {/* <ul className="social-icons d-flex justify-content-center">
            <li style={{ "--i": 1 }}>
              <a href="#">
                <span className="fab fa-facebook"></span>
              </a>
            </li>

            <li style={{ "--i": 2 }}>
              <a href="#">
                <span className="fab fa-twitter"></span>
              </a>
            </li>

            <li style={{ "--i": 3 }}>
              <a href="#">
                <span className="fab fa-instagram"></span>
              </a>
            </li>
          </ul> */}

        </div>

      </div>
    </div>


     <div className="col-md-3">
      <div className="card-view p-0">
        
        <div className="fancy-card-image">
         <img
          src={
            customer?.jewelImg
              ? `${baseURLs}${customer?.jewelImg?.path}${customer?.jewelImg?.altered_file_name}`
              : NoImage
          }
          alt="Jewel"
           className="fancy-img"
        />
        </div>

        <div className="card-content d-flex flex-column align-items-center">
          <h4 className="pt-2 image-content-letter">Jewel Image</h4>

       

        </div>

      </div>
    </div>


     <div className="col-md-3">
      <div className="card-view p-0">
        
        <div className="fancy-card-image">
         <img
          src={
            customer?.optionalImg
              ? `${baseURLs}${customer?.optionalImg?.path}${customer?.optionalImg?.altered_file_name}`
              : NoImage
          }
          alt="opt"
           className="fancy-img"
        />
        </div>

        <div className="card-content d-flex flex-column align-items-center">
          <h4 className="pt-2 image-content-letter">Optional Image</h4>
          

        </div>

      </div>
    </div>

  </div>
</div>


</div>

  
</div>

  
  </div>
  )
}

export default CustomerView
